import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { SingleValue } from "react-select";
import { GroupedOption, IOption, SelectDropdownGrouped } from "../../../../../components/inputs/select-dropdown-grouped/select-dropdown-grouped";
import resolutionListStore from "../../../../resolutions/stores/resolution-list-store";
import SettingStore from "../../../../../stores/setting-store";

const NO_DEFAULT_VALUE = "__NULL__";

interface IProps {
    storeSetting: SettingStore | undefined;
}

/**
 * Own observer so draft default_portal_resolution_id changes re-render the closed control.
 */
const DefaultPortalResolutionSelect: React.FC<IProps> = observer(({ storeSetting }) => {
    useEffect(() => {
        void resolutionListStore.load();
    }, []);

    const noDefaultResolutionOption: IOption = {
        label: "None (system default)",
        value: NO_DEFAULT_VALUE,
    };

    const options: GroupedOption[] = [
        { options: [noDefaultResolutionOption] },
        ...resolutionListStore.getPortalDefaultResolutionListOptions(),
    ];

    const selectedId = storeSetting?.defaultPortalResolutionId ?? null;

    const selectedOption = (): IOption | undefined => {
        if (selectedId === null) {
            return noDefaultResolutionOption;
        }
        for (const group of options) {
            const match = group.options.find(
                (option) =>
                    option.value !== NO_DEFAULT_VALUE &&
                    Number(option.value) === Number(selectedId)
            );
            if (match) {
                return match;
            }
        }
        return undefined;
    };

    const onChange = (v: SingleValue<IOption>) => {
        const raw = v?.value;
        if (raw === NO_DEFAULT_VALUE || raw === undefined || raw === null) {
            storeSetting?.setDefaultPortalResolutionId(null);
            return;
        }
        storeSetting?.setDefaultPortalResolutionId(Number(raw));
    };

    return (
        <SelectDropdownGrouped
            options={options}
            value={selectedOption()}
            onChange={onChange}
            isSearchable={true}
        />
    );
});

export default DefaultPortalResolutionSelect;